const cSharpScript = `
/*Adding Reference of the Web Service in Visual Studio

1. Right click the project in Solution Explorer and choose Add Service Reference option from the context menu.

2. Now in the Add Service Reference Dialog you need to click on the Advanced button.

3. In the Service Reference Settings Dialog you need to click on Add Web Reference button.

4. Now in the Add Web Reference Dialog you need to add the URL of the Web Service and click the Green Go button to discover it. 
   Once the Web Service is discovered, give its reference an appropriate name (e.g. DispatchService) using the Web Reference Name TextBox 
   and click on Add Reference button.

5. Finally you will notice the Web Service Reference has been added to your project.

Calling and Consuming Web Service (ASMX) in ASP.Net

Using the Web Reference Name given in step #4, you can access the Web Service and its methods. Example: */

    private void GetDispatchResponse(string cardImageId, string imageDeliveryKey)
    {
        DispatchService.Dispatch service = new DispatchService.Dispatch();
        DispatchService.GetImageResult result = service.GetImage(cardImageId, imageDeliveryKey);
    }
`;

export default cSharpScript ;